
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: import.meta.env.VITE_KEYCLOAK_URL as string,
    realm: import.meta.env.VITE_KEYCLOAK_REALM as string,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string,
})

keycloak.onAuthSuccess = () => {
    localStorage.setItem('authToken', keycloak.token || '');
    localStorage.setItem('kcToken', keycloak.token || '');
    localStorage.setItem('kcRefreshToken', keycloak.refreshToken || '');
    if(keycloak.idToken){
        localStorage.setItem('idToken', keycloak.idToken || '');
    }
};
keycloak.onAuthRefreshSuccess = () => {
    localStorage.setItem('authToken', keycloak.token || '');
    localStorage.setItem('kcToken', keycloak.token || '');
    localStorage.setItem('kcRefreshToken', keycloak.refreshToken || '');
    if(keycloak.idToken){
        localStorage.setItem('idToken', keycloak.idToken || '');
    }
};

keycloak.onAuthLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('kcToken');
    localStorage.removeItem('kcRefreshToken');
    localStorage.removeItem('idToken');
};

export default keycloak;
